var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

var IconAnnouncement = function IconAnnouncement(props) {
  return React.createElement("svg", __assign({
    viewBox: "0 0 24 24",
    width: 24,
    height: 24
  }, props), React.createElement("path", {
    className: "heroicon-ui",
    d: "M13 16v5a1 1 0 01-1 1H9l-3-6a2 2 0 01-2-2 2 2 0 01-2-2v-2c0-1.1.9-2 2-2 0-1.1.9-2 2-2h7.59l4-4H20a2 2 0 012 2v14a2 2 0 01-2 2h-2.41l-4-4H13zm0-2h1.41l4 4H20V4h-1.59l-4 4H13v6zm-2 0V8H6v2H4v2h2v2h5zm0 2H8.24l2 4H11v-4z"
  }));
};

exports.IconAnnouncement = IconAnnouncement;

var IconArchive = function IconArchive(props) {
  return React.createElement("svg", __assign({
    viewBox: "0 0 24 24",
    width: 24,
    height: 24
  }, props), React.createElement("path", {
    className: "heroicon-ui",
    d: "M20 9v10a2 2 0 01-2 2H6a2 2 0 01-2-2V9a2 2 0 01-2-2V5c0-1.1.9-2 2-2h16a2 2 0 012 2v2a2 2 0 01-2 2zm0-2V5H4v2h16zM6 9v10h12V9H6zm4 2h4a1 1 0 010 2h-4a1 1 0 010-2z"
  }));
};

exports.IconArchive = IconArchive;

var IconArrowDown = function IconArrowDown(props) {
  return React.createElement("svg", __assign({
    viewBox: "0 0 24 24",
    width: 24,
    height: 24
  }, props), React.createElement("path", {
    className: "heroicon-ui",
    d: "M11 18.59V3a1 1 0 012 0v15.59l5.3-5.3a1 1 0 011.4 1.42l-7 7a1 1 0 01-1.4 0l-7-7a1 1 0 011.4-1.42l5.3 5.3z"
  }));
};

exports.IconArrowDown = IconArrowDown;

var IconArrowLeft = function IconArrowLeft(props) {
  return React.createElement("svg", __assign({
    viewBox: "0 0 24 24",
    width: 24,
    height: 24
  }, props), React.createElement("path", {
    className: "heroicon-ui",
    d: "M5.41 11H21a1 1 0 010 2H5.41l5.3 5.3a1 1 0 01-1.42 1.4l-7-7a1 1 0 010-1.4l7-7a1 1 0 011.42 1.4L5.4 11z"
  }));
};

exports.IconArrowLeft = IconArrowLeft;

var IconArrowRight = function IconArrowRight(props) {
  return React.createElement("svg", __assign({
    viewBox: "0 0 24 24",
    width: 24,
    height: 24
  }, props), React.createElement("path", {
    className: "heroicon-ui",
    d: "M18.59 13H3a1 1 0 010-2h15.59l-5.3-5.3a1 1 0 111.42-1.4l7 7a1 1 0 010 1.4l-7 7a1 1 0 01-1.42-1.4l5.3-5.3z"
  }));
};

exports.IconArrowRight = IconArrowRight;

var IconArrowUp = function IconArrowUp(props) {
  return React.createElement("svg", __assign({
    viewBox: "0 0 24 24",
    width: 24,
    height: 24
  }, props), React.createElement("path", {
    className: "heroicon-ui",
    d: "M13 5.41V21a1 1 0 01-2 0V5.41l-5.3 5.3a1 1 0 11-1.4-1.42l7-7a1 1 0 011.4 0l7 7a1 1 0 11-1.4 1.42L13 5.4z"
  }));
};

exports.IconArrowUp = IconArrowUp;

var IconAtSymbol = function IconAtSymbol(props) {
  return React.createElement("svg", __assign({
    viewBox: "0 0 24 24",
    width: 24,
    height: 24
  }, props), React.createElement("path", {
    className: "heroicon-ui",
    d: "M15.6 15.47A4.99 4.99 0 017 12a5 5 0 0110 0v1.5a1.5 1.5 0 103 0V12a8 8 0 10-4.94 7.4 1 1 0 11.77 1.84A10 10 0 1122 12v1.5a3.5 3.5 0 01-6.4 1.97zM12 15a3 3 0 100-6 3 3 0 000 6z"
  }));
};

exports.IconAtSymbol = IconAtSymbol;

var IconBook = function IconBook(props) {
  return React.createElement("svg", __assign({
    viewBox: "0 0 24 24",
    width: 24,
    height: 24
  }, props), React.createElement("path", {
    className: "heroicon-ui",
    d: "M7 5H5v14h14V5h-2v10a1 1 0 01-1.45.9L12 14.11l-3.55 1.77A1 1 0 017 15V5zM5 3h14a2 2 0 012 2v14a2 2 0 01-2 2H5a2 2 0 01-2-2V5c0-1.1.9-2 2-2zm4 2v8.38l2.55-1.27a1 1 0 01.9 0L15 13.38V5H9z"
  }));
};

exports.IconBook = IconBook;

var IconBookmark = function IconBookmark(props) {
  return React.createElement("svg", __assign({
    viewBox: "0 0 24 24",
    width: 24,
    height: 24
  }, props), React.createElement("path", {
    className: "heroicon-ui",
    d: "M12 18.62l-6.55 3.27A1 1 0 014 21V4c0-1.1.9-2 2-2h12a2 2 0 012 2v17a1 1 0 01-1.45.9L12 18.61zM18 4H6v15.38l5.55-2.77a1 1 0 01.9 0L18 19.38V4z"
  }));
};

exports.IconBookmark = IconBookmark;

var IconBriefcase = function IconBriefcase(props) {
  return React.createElement("svg", __assign({
    viewBox: "0 0 24 24",
    width: 24,
    height: 24
  }, props), React.createElement("path", {
    className: "heroicon-ui",
    d: "M8 7V5c0-1.1.9-2 2-2h4a2 2 0 012 2v2h4a2 2 0 012 2v10a2 2 0 01-2 2H4a2 2 0 01-2-2V9c0-1.1.9-2 2-2h4zm8 2H8v10h8V9zm2 0v10h2V9h-2zM6 9H4v10h2V9zm4-2h4V5h-4v2z"
  }));
};

exports.IconBriefcase = IconBriefcase;

var IconBrowser = function IconBrowser(props) {
  return React.createElement("svg", __assign({
    viewBox: "0 0 24 24",
    width: 24,
    height: 24
  }, props), React.createElement("path", {
    className: "heroicon-ui",
    d: "M4 3h16a2 2 0 012 2v14a2 2 0 01-2 2H4a2 2 0 01-2-2V5c0-1.1.9-2 2-2zm16 4V5H4v2h16zm0 2H4v10h16V9z"
  }));
};

exports.IconBrowser = IconBrowser;

var IconBuilding = function IconBuilding(props) {
  return React.createElement("svg", __assign({
    viewBox: "0 0 24 24",
    width: 24,
    height: 24
  }, props), React.createElement("path", {
    className: "heroicon-ui",
    d: "M19 10v6a2 2 0 012 2v2a2 2 0 01-2 2H5a2 2 0 01-2-2v-2c0-1.1.9-2 2-2v-6a2 2 0 01-2-2V7a1 1 0 01.55-.9l8-4a1 1 0 01.9 0l8 4A1 1 0 0121 7v1a2 2 0 01-2 2zm-6 0h-2v6h2v-6zm4 0h-2v6h2v-6zm-8 0H7v6h2v-6zM5 7.62V8h14v-.38l-7-3.5-7 3.5zM5 18v2h14v-2H5z"
  }));
};

exports.IconBuilding = IconBuilding;

var IconCalander = function IconCalander(props) {
  return React.createElement("svg", __assign({
    viewBox: "0 0 24 24",
    width: 24,
    height: 24
  }, props), React.createElement("path", {
    className: "heroicon-ui",
    d: "M17 4h2a2 2 0 012 2v14a2 2 0 01-2 2H5a2 2 0 01-2-2V6c0-1.1.9-2 2-2h2V3a1 1 0 112 0v1h6V3a1 1 0 012 0v1zm-2 2H9v1a1 1 0 11-2 0V6H5v4h14V6h-2v1a1 1 0 01-2 0V6zm4 6H5v8h14v-8z"
  }));
};

exports.IconCalander = IconCalander;

var IconCallIncoming = function IconCallIncoming(props) {
  return React.createElement("svg", __assign({
    viewBox: "0 0 24 24",
    width: 24,
    height: 24
  }, props), React.createElement("path", {
    className: "heroicon-ui",
    d: "M13.04 14.69l1.07-2.14a1 1 0 011.2-.5l6 2A1 1 0 0122 15v5a2 2 0 01-2 2h-2A16 16 0 012 6V4c0-1.1.9-2 2-2h5a1 1 0 01.95.68l2 6a1 1 0 01-.5 1.21L9.3 10.96a10.05 10.05 0 003.73 3.73zM8.28 4H4v2a14 14 0 0014 14h2v-4.28l-4.5-1.5-1.12 2.26a1 1 0 01-1.3.46 12.04 12.04 0 01-6.02-6.01 1 1 0 01.46-1.3l2.26-1.14L8.28 4zm12.01-1.7a1 1 0 011.42 1.4L17.4 8H20a1 1 0 010 2h-5a1 1 0 01-1-1V4a1 1 0 012 0v2.59l4.3-4.3z"
  }));
};

exports.IconCallIncoming = IconCallIncoming;

var IconCallOutgoing = function IconCallOutgoing(props) {
  return React.createElement("svg", __assign({
    viewBox: "0 0 24 24",
    width: 24,
    height: 24
  }, props), React.createElement("path", {
    className: "heroicon-ui",
    d: "M13.04 14.69l1.07-2.14a1 1 0 011.2-.5l6 2A1 1 0 0122 15v5a2 2 0 01-2 2h-2A16 16 0 012 6V4c0-1.1.9-2 2-2h5a1 1 0 01.95.68l2 6a1 1 0 01-.5 1.21L9.3 10.96a10.05 10.05 0 003.73 3.73zM8.28 4H4v2a14 14 0 0014 14h2v-4.28l-4.5-1.5-1.12 2.26a1 1 0 01-1.3.46 12.04 12.04 0 01-6.02-6.01 1 1 0 01.46-1.3l2.26-1.14L8.28 4zm7.43 5.7a1 1 0 11-1.42-1.4L18.6 4H16a1 1 0 010-2h5a1 1 0 011 1v5a1 1 0 01-2 0V5.41l-4.3 4.3z"
  }));
};

exports.IconCallOutgoing = IconCallOutgoing;

var IconCall = function IconCall(props) {
  return React.createElement("svg", __assign({
    viewBox: "0 0 24 24",
    width: 24,
    height: 24
  }, props), React.createElement("path", {
    className: "heroicon-ui",
    d: "M13.04 14.69l1.07-2.14a1 1 0 011.2-.5l6 2A1 1 0 0122 15v5a2 2 0 01-2 2h-2A16 16 0 012 6V4c0-1.1.9-2 2-2h5a1 1 0 01.95.68l2 6a1 1 0 01-.5 1.21L9.3 10.96a10.05 10.05 0 003.73 3.73zM8.28 4H4v2a14 14 0 0014 14h2v-4.28l-4.5-1.5-1.12 2.26a1 1 0 01-1.3.46 12.04 12.04 0 01-6.02-6.01 1 1 0 01.46-1.3l2.26-1.14L8.28 4z"
  }));
};

exports.IconCall = IconCall;

var IconCamera = function IconCamera(props) {
  return React.createElement("svg", __assign({
    viewBox: "0 0 24 24",
    width: 24,
    height: 24
  }, props), React.createElement("path", {
    className: "heroicon-ui",
    d: "M20 7a2 2 0 012 2v10a2 2 0 01-2 2H4a2 2 0 01-2-2V9c0-1.1.9-2 2-2h2.38l1.73-3.45A1 1 0 019 3h6a1 1 0 01.9.55L17.61 7H20zM9.62 5L7.89 8.45A1 1 0 017 9H4v10h16V9h-3a1 1 0 01-.9-.55L14.39 5H9.62zM12 17a4 4 0 110-8 4 4 0 010 8zm0-2a2 2 0 100-4 2 2 0 000 4z"
  }));
};

exports.IconCamera = IconCamera;

var IconCart = function IconCart(props) {
  return React.createElement("svg", __assign({
    viewBox: "0 0 24 24",
    width: 24,
    height: 24
  }, props), React.createElement("path", {
    className: "heroicon-ui",
    d: "M17 16a3 3 0 11-2.83 2H9.83a3 3 0 11-5.62-.1A3 3 0 015 12V4H3a1 1 0 110-2h3a1 1 0 011 1v1h14a1 1 0 01.9 1.45l-4 8a1 1 0 01-.9.55H5a1 1 0 000 2h12zM7 12h9.38l3-6H7v6zm0 8a1 1 0 100-2 1 1 0 000 2zm10 0a1 1 0 100-2 1 1 0 000 2z"
  }));
};

exports.IconCart = IconCart;

var IconChat = function IconChat(props) {
  return React.createElement("svg", __assign({
    viewBox: "0 0 24 24",
    width: 24,
    height: 24
  }, props), React.createElement("path", {
    className: "heroicon-ui",
    d: "M6 14H4a2 2 0 01-2-2V4c0-1.1.9-2 2-2h12a2 2 0 012 2v2h2a2 2 0 012 2v13a1 1 0 01-1.7.7L16.58 18H8a2 2 0 01-2-2v-2zm0-2V8c0-1.1.9-2 2-2h8V4H4v8h2zm14-4H8v8h9a1 1 0 01.7.3l2.3 2.29V8z"
  }));
};

exports.IconChat = IconChat;

var IconCheckCircle = function IconCheckCircle(props) {
  return React.createElement("svg", __assign({
    viewBox: "0 0 24 24",
    width: 24,
    height: 24
  }, props), React.createElement("path", {
    className: "heroicon-ui",
    d: "M12 22a10 10 0 110-20 10 10 0 010 20zm0-2a8 8 0 100-16 8 8 0 000 16zm-2.3-8.7l1.3 1.29 3.3-3.3a1 1 0 011.4 1.42l-4 4a1 1 0 01-1.4 0l-2-2a1 1 0 011.4-1.42z"
  }));
};

exports.IconCheckCircle = IconCheckCircle;

var IconCheveronDown = function IconCheveronDown(props) {
  return React.createElement("svg", __assign({
    viewBox: "0 0 24 24",
    width: 24,
    height: 24
  }, props), React.createElement("path", {
    className: "heroicon-ui",
    d: "M15.3 9.3a1 1 0 011.4 1.4l-4 4a1 1 0 01-1.4 0l-4-4a1 1 0 011.4-1.4l3.3 3.29 3.3-3.3z"
  }));
};

exports.IconCheveronDown = IconCheveronDown;

var IconCheveronLeft = function IconCheveronLeft(props) {
  return React.createElement("svg", __assign({
    viewBox: "0 0 24 24",
    width: 24,
    height: 24
  }, props), React.createElement("path", {
    className: "heroicon-ui",
    d: "M14.7 15.3a1 1 0 01-1.4 1.4l-4-4a1 1 0 010-1.4l4-4a1 1 0 011.4 1.4L11.42 12l3.3 3.3z"
  }));
};

exports.IconCheveronLeft = IconCheveronLeft;

var IconCheveronRight = function IconCheveronRight(props) {
  return React.createElement("svg", __assign({
    viewBox: "0 0 24 24",
    width: 24,
    height: 24
  }, props), React.createElement("path", {
    className: "heroicon-ui",
    d: "M9.3 8.7a1 1 0 011.4-1.4l4 4a1 1 0 010 1.4l-4 4a1 1 0 01-1.4-1.4l3.29-3.3-3.3-3.3z"
  }));
};

exports.IconCheveronRight = IconCheveronRight;

var IconCheveronUp = function IconCheveronUp(props) {
  return React.createElement("svg", __assign({
    viewBox: "0 0 24 24",
    width: 24,
    height: 24
  }, props), React.createElement("path", {
    className: "heroicon-ui",
    d: "M8.7 14.7a1 1 0 01-1.4-1.4l4-4a1 1 0 011.4 0l4 4a1 1 0 01-1.4 1.4L12 11.42l-3.3 3.3z"
  }));
};

exports.IconCheveronUp = IconCheveronUp;

var IconClip = function IconClip(props) {
  return React.createElement("svg", __assign({
    viewBox: "0 0 24 24",
    width: 24,
    height: 24
  }, props), React.createElement("path", {
    className: "heroicon-ui",
    d: "M20.12 11.95l-6.58 6.59a5 5 0 11-7.08-7.07l6.59-6.6a3 3 0 014.24 4.25l-6.58 6.59a1 1 0 11-1.42-1.42l6.59-6.58a1 1 0 00-1.42-1.42l-6.58 6.59a3 3 0 004.24 4.24l6.59-6.58a5 5 0 00-7.08-7.08l-6.58 6.6a7 7 0 009.9 9.9l6.59-6.6a1 1 0 00-1.42-1.4z"
  }));
};

exports.IconClip = IconClip;

var IconClipboard = function IconClipboard(props) {
  return React.createElement("svg", __assign({
    viewBox: "0 0 24 24",
    width: 24,
    height: 24
  }, props), React.createElement("path", {
    className: "heroicon-ui",
    d: "M8 4c0-1.1.9-2 2-2h4a2 2 0 012 2h2a2 2 0 012 2v14a2 2 0 01-2 2H6a2 2 0 01-2-2V6c0-1.1.9-2 2-2h2zm0 2H6v14h12V6h-2a2 2 0 01-2 2h-4a2 2 0 01-2-2zm2-2v2h4V4h-4z"
  }));
};

exports.IconClipboard = IconClipboard;

var IconClock = function IconClock(props) {
  return React.createElement("svg", __assign({
    viewBox: "0 0 24 24",
    width: 24,
    height: 24
  }, props), React.createElement("path", {
    className: "heroicon-ui",
    d: "M12 22a10 10 0 110-20 10 10 0 010 20zm0-2a8 8 0 100-16 8 8 0 000 16zm1-8.41l2.54 2.53a1 1 0 01-1.42 1.42L11.3 12.7a1 1 0 01-.3-.7V8a1 1 0 012 0v3.59z"
  }));
};

exports.IconClock = IconClock;

var IconCode = function IconCode(props) {
  return React.createElement("svg", __assign({
    viewBox: "0 0 24 24",
    width: 24,
    height: 24
  }, props), React.createElement("path", {
    className: "heroicon-ui",
    d: "M20.59 12l-3.3-3.3a1 1 0 111.42-1.4l4 4a1 1 0 010 1.4l-4 4a1 1 0 01-1.42-1.4l3.3-3.3zM3.4 12l3.3 3.3a1 1 0 01-1.42 1.4l-4-4a1 1 0 010-1.4l4-4A1 1 0 016.7 8.7L3.4 12zm7.56 8.24a1 1 0 01-1.94-.48l4-16a1 1 0 111.94.48l-4 16z"
  }));
};

exports.IconCode = IconCode;

var IconCog = function IconCog(props) {
  return React.createElement("svg", __assign({
    viewBox: "0 0 24 24",
    width: 24,
    height: 24
  }, props), React.createElement("path", {
    className: "heroicon-ui",
    d: "M9 4.58V4c0-1.1.9-2 2-2h2a2 2 0 012 2v.58a8 8 0 011.92 1.11l.5-.29a2 2 0 012.74.73l1 1.74a2 2 0 01-.73 2.73l-.5.29a8.06 8.06 0 010 2.22l.5.3a2 2 0 01.73 2.72l-1 1.74a2 2 0 01-2.73.73l-.5-.3A8 8 0 0115 19.43V20a2 2 0 01-2 2h-2a2 2 0 01-2-2v-.58a8 8 0 01-1.92-1.11l-.5.29a2 2 0 01-2.74-.73l-1-1.74a2 2 0 01.73-2.73l.5-.29a8.06 8.06 0 010-2.22l-.5-.3a2 2 0 01-.73-2.72l1-1.74a2 2 0 012.73-.73l.5.3A8 8 0 019 4.57zM7.88 7.64l-.54.51-1.77-1.02-1 1.74 1.76 1.01-.17.73a6.02 6.02 0 000 2.78l.17.73-1.76 1.01 1 1.74 1.77-1.02.54.51a6 6 0 002.4 1.4l.72.2V20h2v-2.04l.71-.2a6 6 0 002.41-1.4l.54-.51 1.77 1.02 1-1.74-1.76-1.01.17-.73a6.02 6.02 0 000-2.78l-.17-.73 1.76-1.01-1-1.74-1.77 1.02-.54-.51a6 6 0 00-2.4-1.4l-.72-.2V4h-2v2.04l-.71.2a6 6 0 00-2.41 1.4zM12 16a4 4 0 110-8 4 4 0 010 8zm0-2a2 2 0 100-4 2 2 0 000 4z"
  }));
};

exports.IconCog = IconCog;

var IconComment = function IconComment(props) {
  return React.createElement("svg", __assign({
    viewBox: "0 0 24 24",
    width: 24,
    height: 24
  }, props), React.createElement("path", {
    className: "heroicon-ui",
    d: "M2 15V5c0-1.1.9-2 2-2h16a2 2 0 012 2v15a1 1 0 01-1.7.7L16.58 17H4a2 2 0 01-2-2zM20 5H4v10h13a1 1 0 01.7.3l2.3 2.29V5z"
  }));
};

exports.IconComment = IconComment;

var IconCompass = function IconCompass(props) {
  return React.createElement("svg", __assign({
    viewBox: "0 0 24 24",
    width: 24,
    height: 24
  }, props), React.createElement("path", {
    className: "heroicon-ui",
    d: "M12 22a10 10 0 110-20 10 10 0 010 20zm0-2a8 8 0 100-16 8 8 0 000 16zM9.56 8.93l6.37-2.12a1 1 0 011.26 1.26l-2.12 6.37a1 1 0 01-.63.63l-6.37 2.12a1 1 0 01-1.26-1.26l2.12-6.37a1 1 0 01.63-.63zm-.22 5.73l4-1.33 1.32-4-4 1.34-1.32 4z"
  }));
};

exports.IconCompass = IconCompass;

var IconCurrencyDollar = function IconCurrencyDollar(props) {
  return React.createElement("svg", __assign({
    viewBox: "0 0 24 24",
    width: 24,
    height: 24
  }, props), React.createElement("path", {
    className: "heroicon-ui",
    d: "M12 22a10 10 0 110-20 10 10 0 010 20zm0-2a8 8 0 100-16 8 8 0 000 16zm1-11v2h1a3 3 0 010 6h-1v1a1 1 0 01-2 0v-1H8a1 1 0 010-2h3v-2h-1a3 3 0 010-6h1V6a1 1 0 012 0v1h3a1 1 0 010 2h-3zm-2 0h-1a1 1 0 100 2h1V9zm2 6h1a1 1 0 000-2h-1v2z"
  }));
};

exports.IconCurrencyDollar = IconCurrencyDollar;

var IconDashboard = function IconDashboard(props) {
  return React.createElement("svg", __assign({
    viewBox: "0 0 24 24",
    width: 24,
    height: 24
  }, props), React.createElement("path", {
    className: "heroicon-ui",
    d: "M12 22a10 10 0 110-20 10 10 0 010 20zM5.68 7.1A7.96 7.96 0 004.06 11H5a1 1 0 010 2h-.94a7.95 7.95 0 001.32 3.5A9.96 9.96 0 0111 14.05V9a1 1 0 012 0v5.05a9.96 9.96 0 015.62 2.45 7.95 7.95 0 001.32-3.5H19a1 1 0 010-2h.94a7.96 7.96 0 00-1.62-3.9l-.66.66a1 1 0 11-1.42-1.42l.67-.66A7.96 7.96 0 0013 4.06V5a1 1 0 01-2 0v-.94c-1.46.18-2.8.76-3.9 1.62l.66.66a1 1 0 01-1.42 1.42l-.66-.67zM6.71 18a7.97 7.97 0 0010.58 0 7.97 7.97 0 00-10.58 0z"
  }));
};

exports.IconDashboard = IconDashboard;

var IconDesktop = function IconDesktop(props) {
  return React.createElement("svg", __assign({
    viewBox: "0 0 24 24",
    width: 24,
    height: 24
  }, props), React.createElement("path", {
    className: "heroicon-ui",
    d: "M13 17h-2v2h2v-2zm2 0v2h2a1 1 0 010 2H7a1 1 0 010-2h2v-2H4a2 2 0 01-2-2V5c0-1.1.9-2 2-2h16a2 2 0 012 2v10a2 2 0 01-2 2h-5zM4 5v10h16V5H4z"
  }));
};

exports.IconDesktop = IconDesktop;

var IconDiscount = function IconDiscount(props) {
  return React.createElement("svg", __assign({
    viewBox: "0 0 24 24",
    width: 24,
    height: 24
  }, props), React.createElement("path", {
    className: "heroicon-ui",
    d: "M7.7 6.3L9 7.58l4.3-4.3a1 1 0 011.4 1.42L10.42 9l4.3 4.3a1 1 0 01-1.42 1.4L9 10.42l-1.3 1.3a3 3 0 11-1.4-1.42L7.58 9l-1.3-1.3A3 3 0 117.7 6.3zM21 8a1 1 0 011 1v1a1 1 0 01-2 0 1 1 0 010-2h1zM4 20a1 1 0 010 2H3a1 1 0 01-1-1v-1a1 1 0 012 0zm17 2h-1a1 1 0 010-2 1 1 0 012 0v1a1 1 0 01-1 1zM14 8h2a1 1 0 010 2h-2a1 1 0 010-2zm7 5a1 1 0 011 1v2a1 1 0 01-2 0v-2a1 1 0 011-1zm-7 7h2a1 1 0 010 2h-2a1 1 0 010-2zm-6 0h2a1 1 0 010 2H8a1 1 0 010-2zm-2.3-6.3a1 1 0 10-1.4-1.4 1 1 0 001.4 1.4zM5 6a1 1 0 100-2 1 1 0 000 2z"
  }));
};

exports.IconDiscount = IconDiscount;

var IconDownload = function IconDownload(props) {
  return React.createElement("svg", __assign({
    viewBox: "0 0 24 24",
    width: 24,
    height: 24
  }, props), React.createElement("path", {
    className: "heroicon-ui",
    d: "M11 14.59V3a1 1 0 012 0v11.59l3.3-3.3a1 1 0 011.4 1.42l-5 5a1 1 0 01-1.4 0l-5-5a1 1 0 011.4-1.42l3.3 3.3zM3 17a1 1 0 012 0v3h14v-3a1 1 0 012 0v3a2 2 0 01-2 2H5a2 2 0 01-2-2v-3z"
  }));
};

exports.IconDownload = IconDownload;

var IconDuplicate = function IconDuplicate(props) {
  return React.createElement("svg", __assign({
    viewBox: "0 0 24 24",
    width: 24,
    height: 24
  }, props), React.createElement("path", {
    className: "heroicon-ui",
    d: "M17 7h2.25c.97 0 1.75.78 1.75 1.75v10.5c0 .97-.78 1.75-1.75 1.75H8.75C7.78 21 7 20.22 7 19.25V17H4.75C3.78 17 3 16.22 3 15.25V4.75C3 3.78 3.78 3 4.75 3h10.5c.97 0 1.75.78 1.75 1.75V7zm-2 0V5H5v10h2V8.75C7 7.78 7.78 7 8.75 7H15zM9 9v10h10V9H9z"
  }));
};

exports.IconDuplicate = IconDuplicate;

var IconEdit = function IconEdit(props) {
  return React.createElement("svg", __assign({
    viewBox: "0 0 24 24",
    width: 24,
    height: 24
  }, props), React.createElement("path", {
    className: "heroicon-ui",
    d: "M6.3 12.3l10-10a1 1 0 011.4 0l4 4a1 1 0 010 1.4l-10 10a1 1 0 01-.7.3H7a1 1 0 01-1-1v-4a1 1 0 01.3-.7zM8 16h2.59l9-9L17 4.41l-9 9V16zm10-2a1 1 0 012 0v6a2 2 0 01-2 2H4a2 2 0 01-2-2V6c0-1.1.9-2 2-2h6a1 1 0 010 2H4v14h14v-6z"
  }));
};

exports.IconEdit = IconEdit;

var IconEmotionHappy = function IconEmotionHappy(props) {
  return React.createElement("svg", __assign({
    viewBox: "0 0 24 24",
    width: 24,
    height: 24
  }, props), React.createElement("path", {
    className: "heroicon-ui",
    d: "M12 22a10 10 0 110-20 10 10 0 010 20zm0-2a8 8 0 100-16 8 8 0 000 16zm-3.54-4.46a1 1 0 011.42-1.42 3 3 0 004.24 0 1 1 0 011.42 1.42 5 5 0 01-7.08 0zM9 11a1 1 0 110-2 1 1 0 010 2zm6 0a1 1 0 110-2 1 1 0 010 2z"
  }));
};

exports.IconEmotionHappy = IconEmotionHappy;

var IconEmotionSad = function IconEmotionSad(props) {
  return React.createElement("svg", __assign({
    viewBox: "0 0 24 24",
    width: 24,
    height: 24
  }, props), React.createElement("path", {
    className: "heroicon-ui",
    d: "M12 22a10 10 0 110-20 10 10 0 010 20zm0-2a8 8 0 100-16 8 8 0 000 16zm-3.54-4.54a5 5 0 017.08 0 1 1 0 01-1.42 1.42 3 3 0 00-4.24 0 1 1 0 01-1.42-1.42zM9 11a1 1 0 110-2 1 1 0 010 2zm6 0a1 1 0 110-2 1 1 0 010 2z"
  }));
};

exports.IconEmotionSad = IconEmotionSad;

var IconExclamation = function IconExclamation(props) {
  return React.createElement("svg", __assign({
    viewBox: "0 0 24 24",
    width: 24,
    height: 24
  }, props), React.createElement("path", {
    className: "heroicon-ui",
    d: "M12 2a10 10 0 110 20 10 10 0 010-20zm0 2a8 8 0 100 16 8 8 0 000-16zm0 9a1 1 0 01-1-1V8a1 1 0 012 0v4a1 1 0 01-1 1zm0 4a1 1 0 110-2 1 1 0 010 2z"
  }));
};

exports.IconExclamation = IconExclamation;

var IconExternalLink = function IconExternalLink(props) {
  return React.createElement("svg", __assign({
    viewBox: "0 0 24 24",
    width: 24,
    height: 24
  }, props), React.createElement("path", {
    className: "heroicon-ui",
    d: "M19 6.41L8.7 16.71a1 1 0 11-1.4-1.42L17.58 5H14a1 1 0 010-2h6a1 1 0 011 1v6a1 1 0 01-2 0V6.41zM17 14a1 1 0 012 0v5a2 2 0 01-2 2H5a2 2 0 01-2-2V7c0-1.1.9-2 2-2h5a1 1 0 010 2H5v12h12v-5z"
  }));
};

exports.IconExternalLink = IconExternalLink;

var IconFileBlank = function IconFileBlank(props) {
  return React.createElement("svg", __assign({
    viewBox: "0 0 24 24",
    width: 24,
    height: 24
  }, props), React.createElement("path", {
    className: "heroicon-ui",
    d: "M6 2h9a1 1 0 01.7.3l4 4a1 1 0 01.3.7v13a2 2 0 01-2 2H6a2 2 0 01-2-2V4c0-1.1.9-2 2-2zm9 2.41V7h2.59L15 4.41zM18 9h-3a2 2 0 01-2-2V4H6v16h12V9z"
  }));
};

exports.IconFileBlank = IconFileBlank;

var IconFileMinus = function IconFileMinus(props) {
  return React.createElement("svg", __assign({
    viewBox: "0 0 24 24",
    width: 24,
    height: 24
  }, props), React.createElement("path", {
    className: "heroicon-ui",
    d: "M6 2h9a1 1 0 01.7.3l4 4a1 1 0 01.3.7v13a2 2 0 01-2 2H6a2 2 0 01-2-2V4c0-1.1.9-2 2-2zm9 2.41V7h2.59L15 4.41zM18 9h-3a2 2 0 01-2-2V4H6v16h12V9zm-2 4a1 1 0 01-1 1H9a1 1 0 010-2h6a1 1 0 011 1z"
  }));
};

exports.IconFileMinus = IconFileMinus;

var IconFilePlus = function IconFilePlus(props) {
  return React.createElement("svg", __assign({
    viewBox: "0 0 24 24",
    width: 24,
    height: 24
  }, props), React.createElement("path", {
    className: "heroicon-ui",
    d: "M6 2h9a1 1 0 01.7.3l4 4a1 1 0 01.3.7v13a2 2 0 01-2 2H6a2 2 0 01-2-2V4c0-1.1.9-2 2-2zm9 2.41V7h2.59L15 4.41zM18 9h-3a2 2 0 01-2-2V4H6v16h12V9zm-5 4h2a1 1 0 010 2h-2v2a1 1 0 01-2 0v-2H9a1 1 0 010-2h2v-2a1 1 0 012 0v2z"
  }));
};

exports.IconFilePlus = IconFilePlus;

var IconFile = function IconFile(props) {
  return React.createElement("svg", __assign({
    viewBox: "0 0 24 24",
    width: 24,
    height: 24
  }, props), React.createElement("path", {
    className: "heroicon-ui",
    d: "M6 2h9a1 1 0 01.7.3l4 4a1 1 0 01.3.7v13a2 2 0 01-2 2H6a2 2 0 01-2-2V4c0-1.1.9-2 2-2zm9 2.41V7h2.59L15 4.41zM18 9h-3a2 2 0 01-2-2V4H6v16h12V9zm-2 7a1 1 0 01-1 1H9a1 1 0 010-2h6a1 1 0 011 1zm0-4a1 1 0 01-1 1H9a1 1 0 010-2h6a1 1 0 011 1zm-5-4a1 1 0 01-1 1H9a1 1 0 110-2h1a1 1 0 011 1z"
  }));
};

exports.IconFile = IconFile;

var IconFilm = function IconFilm(props) {
  return React.createElement("svg", __assign({
    viewBox: "0 0 24 24",
    width: 24,
    height: 24
  }, props), React.createElement("path", {
    className: "heroicon-ui",
    d: "M5 3h14a2 2 0 012 2v14a2 2 0 01-2 2H5a2 2 0 01-2-2V5c0-1.1.9-2 2-2zm14 12v-2h-2v2h2zm0 2h-2v2h2v-2zM5 15h2v-2H5v2zm0 2v2h2v-2H5zm14-8h-2v2h2V9zm0-2V5h-2v2h2zM5 9v2h2V9H5zm0-2h2V5H5v2zm4 4h6V5H9v6zm0 2v6h6v-6H9z"
  }));
};

exports.IconFilm = IconFilm;

var IconFilter = function IconFilter(props) {
  return React.createElement("svg", __assign({
    viewBox: "0 0 24 24",
    width: 24,
    height: 24
  }, props), React.createElement("path", {
    className: "heroicon-ui",
    d: "M2.3 7.7A1 1 0 012 7V3a1 1 0 011-1h18a1 1 0 011 1v4a1 1 0 01-.3.7L15 14.42V17a1 1 0 01-.3.7l-4 4A1 1 0 019 21v-6.59l-6.7-6.7zM4 4v2.59l6.7 6.7a1 1 0 01.3.71v4.59l2-2V14a1 1 0 01.3-.7L20 6.58V4H4z"
  }));
};

exports.IconFilter = IconFilter;

var IconFlag = function IconFlag(props) {
  return React.createElement("svg", __assign({
    viewBox: "0 0 24 24",
    width: 24,
    height: 24
  }, props), React.createElement("path", {
    className: "heroicon-ui",
    d: "M4 16v5a1 1 0 01-2 0V3a1 1 0 011-1h8.5a1 1 0 01.7.3l.71.7H21a1 1 0 01.9 1.45L19.11 10l2.77 5.55A1 1 0 0121 17h-8.5a1 1 0 01-.7-.3l-.71-.7H4zm7-12H4v10h7.5a1 1 0 01.7.3l.71.7h6.47l-2.27-4.55a1 1 0 010-.9L19.38 5H13v4a1 1 0 01-2 0V4z"
  }));
};

exports.IconFlag = IconFlag;

var IconFolderMinus = function IconFolderMinus(props) {
  return React.createElement("svg", __assign({
    viewBox: "0 0 24 24",
    width: 24,
    height: 24
  }, props), React.createElement("path", {
    className: "heroicon-ui",
    d: "M20 6a2 2 0 012 2v10a2 2 0 01-2 2H4a2 2 0 01-2-2V6c0-1.1.9-2 2-2h7.41l2 2H20zM4 6v12h16V8h-7.41l-2-2H4zm12 7a1 1 0 01-1 1H9a1 1 0 010-2h6a1 1 0 011 1z"
  }));
};

exports.IconFolderMinus = IconFolderMinus;

var IconFolderPlus = function IconFolderPlus(props) {
  return React.createElement("svg", __assign({
    viewBox: "0 0 24 24",
    width: 24,
    height: 24
  }, props), React.createElement("path", {
    className: "heroicon-ui",
    d: "M20 6a2 2 0 012 2v10a2 2 0 01-2 2H4a2 2 0 01-2-2V6c0-1.1.9-2 2-2h7.41l2 2H20zM4 6v12h16V8h-7.41l-2-2H4zm9 6h2a1 1 0 010 2h-2v2a1 1 0 01-2 0v-2H9a1 1 0 010-2h2v-2a1 1 0 012 0v2z"
  }));
};

exports.IconFolderPlus = IconFolderPlus;

var IconFolder = function IconFolder(props) {
  return React.createElement("svg", __assign({
    viewBox: "0 0 24 24",
    width: 24,
    height: 24
  }, props), React.createElement("path", {
    className: "heroicon-ui",
    d: "M20 6a2 2 0 012 2v10a2 2 0 01-2 2H4a2 2 0 01-2-2V6c0-1.1.9-2 2-2h7.41l2 2H20zM4 6v12h16V8h-7.41l-2-2H4z"
  }));
};

exports.IconFolder = IconFolder;

var IconGlobe = function IconGlobe(props) {
  return React.createElement("svg", __assign({
    viewBox: "0 0 24 24",
    width: 24,
    height: 24
  }, props), React.createElement("path", {
    className: "heroicon-ui",
    d: "M4.06 13a8 8 0 005.18 6.51A18.5 18.5 0 018.02 13H4.06zm0-2h3.96a18.5 18.5 0 011.22-6.51A8 8 0 004.06 11zm15.88 0a8 8 0 00-5.18-6.51A18.5 18.5 0 0115.98 11h3.96zm0 2h-3.96a18.5 18.5 0 01-1.22 6.51A8 8 0 0019.94 13zm-9.92 0c.16 3.95 1.23 7 1.98 7s1.82-3.05 1.98-7h-3.96zm0-2h3.96c-.16-3.95-1.23-7-1.98-7s-1.82 3.05-1.98 7zM12 22a10 10 0 110-20 10 10 0 010 20z"
  }));
};

exports.IconGlobe = IconGlobe;

var IconGraphBar = function IconGraphBar(props) {
  return React.createElement("svg", __assign({
    viewBox: "0 0 24 24",
    width: 24,
    height: 24
  }, props), React.createElement("path", {
    className: "heroicon-ui",
    d: "M20 22H4a2 2 0 01-2-2v-8c0-1.1.9-2 2-2h4V8c0-1.1.9-2 2-2h4V4c0-1.1.9-2 2-2h4a2 2 0 012 2v16a2 2 0 01-2 2zM14 8h-4v12h4V8zm-6 4H4v8h4v-8zm8-8v16h4V4h-4z"
  }));
};

exports.IconGraphBar = IconGraphBar;

var IconGrid = function IconGrid(props) {
  return React.createElement("svg", __assign({
    viewBox: "0 0 24 24",
    width: 24,
    height: 24
  }, props), React.createElement("path", {
    className: "heroicon-ui",
    d: "M5 3h4a2 2 0 012 2v4a2 2 0 01-2 2H5a2 2 0 01-2-2V5c0-1.1.9-2 2-2zm0 2v4h4V5H5zm10-2h4a2 2 0 012 2v4a2 2 0 01-2 2h-4a2 2 0 01-2-2V5c0-1.1.9-2 2-2zm0 2v4h4V5h-4zM5 13h4a2 2 0 012 2v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4c0-1.1.9-2 2-2zm0 2v4h4v-4H5zm10-2h4a2 2 0 012 2v4a2 2 0 01-2 2h-4a2 2 0 01-2-2v-4c0-1.1.9-2 2-2zm0 2v4h4v-4h-4z"
  }));
};

exports.IconGrid = IconGrid;

var IconGroup = function IconGroup(props) {
  return React.createElement("svg", __assign({
    viewBox: "0 0 24 24",
    width: 24,
    height: 24
  }, props), React.createElement("path", {
    className: "heroicon-ui",
    d: "M9 12A5 5 0 119 2a5 5 0 010 10zm0-2a3 3 0 100-6 3 3 0 000 6zm7 11a1 1 0 01-2 0v-2a3 3 0 00-3-3H7a3 3 0 00-3 3v2a1 1 0 01-2 0v-2a5 5 0 015-5h4a5 5 0 015 5v2zm1-5a1 1 0 010-2 5 5 0 015 5v2a1 1 0 01-2 0v-2a3 3 0 00-3-3zm-2-4a1 1 0 010-2 3 3 0 000-6 1 1 0 010-2 5 5 0 010 10z"
  }));
};

exports.IconGroup = IconGroup;

var IconHashtag = function IconHashtag(props) {
  return React.createElement("svg", __assign({
    viewBox: "0 0 24 24",
    width: 24,
    height: 24
  }, props), React.createElement("path", {
    className: "heroicon-ui",
    d: "M11.03 8h3.94l1.06-4.24a1 1 0 111.94.48L17.03 8H20a1 1 0 010 2h-3.47l-1 4H18a1 1 0 110 2h-2.97l-1.06 4.25a1 1 0 11-1.94-.49l.94-3.76H9.03l-1.06 4.25a1 1 0 11-1.94-.49L6.97 16H4a1 1 0 010-2h3.47l1-4H6a1 1 0 010-2h2.97l1.06-4.24a1 1 0 111.94.48L11.03 8zm-.5 2l-1 4h3.94l1-4h-3.94z"
  }));
};

exports.IconHashtag = IconHashtag;

var IconHeart = function IconHeart(props) {
  return React.createElement("svg", __assign({
    viewBox: "0 0 24 24",
    width: 24,
    height: 24
  }, props), React.createElement("path", {
    className: "heroicon-ui",
    d: "M12.76 3.76a6 6 0 018.48 8.48l-8.53 8.54a1 1 0 01-1.42 0l-8.53-8.54a6 6 0 018.48-8.48l.76.75.76-.75zm7.07 7.07a4 4 0 10-5.66-5.66l-1.46 1.47a1 1 0 01-1.42 0L9.83 5.17a4 4 0 10-5.66 5.66L12 18.66l7.83-7.83z"
  }));
};

exports.IconHeart = IconHeart;

var IconHelp = function IconHelp(props) {
  return React.createElement("svg", __assign({
    viewBox: "0 0 24 24",
    width: 24,
    height: 24
  }, props), React.createElement("path", {
    className: "heroicon-ui",
    d: "M12 22a10 10 0 110-20 10 10 0 010 20zm0-2a8 8 0 100-16 8 8 0 000 16zM10.59 8.59a1 1 0 11-1.42-1.42 4 4 0 115.66 5.66l-2.12 2.12a1 1 0 11-1.42-1.42l2.12-2.12A2 2 0 0010.6 8.6zM12 18a1 1 0 110-2 1 1 0 010 2z"
  }));
};

exports.IconHelp = IconHelp;

var IconHome = function IconHome(props) {
  return React.createElement("svg", __assign({
    viewBox: "0 0 24 24",
    width: 24,
    height: 24
  }, props), React.createElement("path", {
    className: "heroicon-ui",
    d: "M13 20v-5h-2v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-7.59l-.3.3a1 1 0 11-1.4-1.42l9-9a1 1 0 011.4 0l9 9a1 1 0 01-1.4 1.42l-.3-.3V20a2 2 0 01-2 2h-3a2 2 0 01-2-2zm5 0v-9.59l-6-6-6 6V20h3v-5c0-1.1.9-2 2-2h2a2 2 0 012 2v5h3z"
  }));
};

exports.IconHome = IconHome;

var IconImage = function IconImage(props) {
  return React.createElement("svg", __assign({
    viewBox: "0 0 24 24",
    width: 24,
    height: 24
  }, props), React.createElement("path", {
    className: "heroicon-ui",
    d: "M4 4h16a2 2 0 012 2v12a2 2 0 01-2 2H4a2 2 0 01-2-2V6c0-1.1.9-2 2-2zm16 8.59V6H4v6.59l4.3-4.3a1 1 0 011.4 0l5.3 5.3 2.3-2.3a1 1 0 011.4 0l1.3 1.3zm0 2.82l-2-2-2.3 2.3a1 1 0 01-1.4 0L9 10.4l-5 5V18h16v-2.59zM15 10a1 1 0 110-2 1 1 0 010 2z"
  }));
};

exports.IconImage = IconImage;

var IconInbox = function IconInbox(props) {
  return React.createElement("svg", __assign({
    viewBox: "0 0 24 24",
    width: 24,
    height: 24
  }, props), React.createElement("path", {
    className: "heroicon-ui",
    d: "M5 3h14a2 2 0 012 2v14a2 2 0 01-2 2H5a2 2 0 01-2-2V5c0-1.1.9-2 2-2zm0 10v6h14v-6h-2.38l-1.45 2.9a2 2 0 01-1.79 1.1h-2.76a2 2 0 01-1.8-1.1L7.39 13H5zm14-2V5H5v6h2.38a2 2 0 011.8 1.1l1.44 2.9h2.76l1.45-2.9a2 2 0 011.79-1.1H19z"
  }));
};

exports.IconInbox = IconInbox;

var IconInformation = function IconInformation(props) {
  return React.createElement("svg", __assign({
    viewBox: "0 0 24 24",
    width: 24,
    height: 24
  }, props), React.createElement("path", {
    className: "heroicon-ui",
    d: "M12 22a10 10 0 110-20 10 10 0 010 20zm0-2a8 8 0 100-16 8 8 0 000 16zm0-9a1 1 0 011 1v4a1 1 0 01-2 0v-4a1 1 0 011-1zm0-4a1 1 0 110 2 1 1 0 010-2z"
  }));
};

exports.IconInformation = IconInformation;

var IconKey = function IconKey(props) {
  return React.createElement("svg", __assign({
    viewBox: "0 0 24 24",
    width: 24,
    height: 24
  }, props), React.createElement("path", {
    className: "heroicon-ui",
    d: "M11.85 17.56a1.5 1.5 0 01-1.06.44H10v.5c0 .83-.67 1.5-1.5 1.5H8v.5c0 .83-.67 1.5-1.5 1.5H4a2 2 0 01-2-2v-2.59A2 2 0 012.59 16l5.56-5.56A7.03 7.03 0 0115 2a7 7 0 11-1.44 13.85l-1.7 1.71zm1.12-3.95l.58.18a5 5 0 10-3.34-3.34l.18.58L4 17.4V20h2v-.5c0-.83.67-1.5 1.5-1.5H8v-.5c0-.83.67-1.5 1.5-1.5h1.09l2.38-2.39zM18 9a1 1 0 01-2 0 1 1 0 00-1-1 1 1 0 010-2 3 3 0 013 3z"
  }));
};

exports.IconKey = IconKey;

var IconLink = function IconLink(props) {
  return React.createElement("svg", __assign({
    viewBox: "0 0 24 24",
    width: 24,
    height: 24
  }, props), React.createElement("path", {
    className: "heroicon-ui",
    d: "M19.48 13.03A4 4 0 0116 19h-4a4 4 0 110-8h1a1 1 0 000-2h-1a6 6 0 100 12h4a6 6 0 005.21-8.98L21.2 12a1 1 0 10-1.72 1.03zM4.52 10.97A4 4 0 018 5h4a4 4 0 110 8h-1a1 1 0 000 2h1a6 6 0 100-12H8a6 6 0 00-5.21 8.98l.01.02a1 1 0 101.72-1.03z"
  }));
};

exports.IconLink = IconLink;

var IconLocation = function IconLocation(props) {
  return React.createElement("svg", __assign({
    viewBox: "0 0 24 24",
    width: 24,
    height: 24
  }, props), React.createElement("path", {
    className: "heroicon-ui",
    d: "M5.64 16.36a9 9 0 1112.72 0l-5.65 5.66a1 1 0 01-1.42 0l-5.65-5.66zm11.31-1.41a7 7 0 10-9.9 0L12 19.9l4.95-4.95zM12 14a4 4 0 110-8 4 4 0 010 8zm0-2a2 2 0 100-4 2 2 0 000 4z"
  }));
};

exports.IconLocation = IconLocation;

var IconLockClosed = function IconLockClosed(props) {
  return React.createElement("svg", __assign({
    viewBox: "0 0 24 24",
    width: 24,
    height: 24
  }, props), React.createElement("path", {
    className: "heroicon-ui",
    d: "M7 10V7a5 5 0 1110 0v3h2a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2v-8c0-1.1.9-2 2-2h2zm2 0h6V7a3 3 0 00-6 0v3zm-4 2v8h14v-8H5zm7 2a1 1 0 011 1v2a1 1 0 01-2 0v-2a1 1 0 011-1z"
  }));
};

exports.IconLockClosed = IconLockClosed;

var IconLockOpen = function IconLockOpen(props) {
  return React.createElement("svg", __assign({
    viewBox: "0 0 24 24",
    width: 24,
    height: 24
  }, props), React.createElement("path", {
    className: "heroicon-ui",
    d: "M9 10h10a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2v-8c0-1.1.9-2 2-2h2V7a5 5 0 1110 0 1 1 0 01-2 0 3 3 0 00-6 0v3zm-4 2v8h14v-8H5zm7 2a1 1 0 011 1v2a1 1 0 01-2 0v-2a1 1 0 011-1z"
  }));
};

exports.IconLockOpen = IconLockOpen;

var IconMail = function IconMail(props) {
  return React.createElement("svg", __assign({
    viewBox: "0 0 24 24",
    width: 24,
    height: 24
  }, props), React.createElement("path", {
    className: "heroicon-ui",
    d: "M4 4h16a2 2 0 012 2v12a2 2 0 01-2 2H4a2 2 0 01-2-2V6c0-1.1.9-2 2-2zm16 3.38V6H4v1.38l8 4 8-4zm0 2.24l-7.55 3.77a1 1 0 01-.9 0L4 9.62V18h16V9.62z"
  }));
};

exports.IconMail = IconMail;

var IconMap = function IconMap(props) {
  return React.createElement("svg", __assign({
    viewBox: "0 0 24 24",
    width: 24,
    height: 24
  }, props), React.createElement("path", {
    className: "heroicon-ui",
    d: "M14 5.62l-4 2v10.76l4-2V5.62zm2 0v10.76l4 2V7.62l-4-2zm-8 2l-4-2v10.76l4 2V7.62zm7 10.5L9.45 20.9a1 1 0 01-.9 0l-6-3A1 1 0 012 17V4a1 1 0 011.45-.9L9 5.89l5.55-2.77a1 1 0 01.9 0l6 3A1 1 0 0122 7v13a1 1 0 01-1.45.89L15 18.12z"
  }));
};

exports.IconMap = IconMap;

var IconMenu = function IconMenu(props) {
  return React.createElement("svg", __assign({
    viewBox: "0 0 24 24",
    width: 24,
    height: 24
  }, props), React.createElement("path", {
    className: "heroicon-ui",
    d: "M4 5h16a1 1 0 010 2H4a1 1 0 110-2zm0 6h16a1 1 0 010 2H4a1 1 0 010-2zm0 6h16a1 1 0 010 2H4a1 1 0 010-2z"
  }));
};

exports.IconMenu = IconMenu;

var IconMicrophone = function IconMicrophone(props) {
  return React.createElement("svg", __assign({
    viewBox: "0 0 24 24",
    width: 24,
    height: 24
  }, props), React.createElement("path", {
    className: "heroicon-ui",
    d: "M13 18.94V21h3a1 1 0 010 2H8a1 1 0 010-2h3v-2.06A8 8 0 014 11a1 1 0 012 0 6 6 0 1012 0 1 1 0 012 0 8 8 0 01-7 7.94zM12 1a4 4 0 014 4v6a4 4 0 11-8 0V5a4 4 0 014-4zm0 2a2 2 0 00-2 2v6a2 2 0 104 0V5a2 2 0 00-2-2z"
  }));
};

exports.IconMicrophone = IconMicrophone;

var IconMinusCircle = function IconMinusCircle(props) {
  return React.createElement("svg", __assign({
    viewBox: "0 0 24 24",
    width: 24,
    height: 24
  }, props), React.createElement("path", {
    className: "heroicon-ui",
    d: "M12 22a10 10 0 110-20 10 10 0 010 20zm0-2a8 8 0 100-16 8 8 0 000 16zm4-8a1 1 0 01-1 1H9a1 1 0 010-2h6a1 1 0 011 1z"
  }));
};

exports.IconMinusCircle = IconMinusCircle;

var IconMinusSquare = function IconMinusSquare(props) {
  return React.createElement("svg", __assign({
    viewBox: "0 0 24 24",
    width: 24,
    height: 24
  }, props), React.createElement("path", {
    className: "heroicon-ui",
    d: "M5 3h14a2 2 0 012 2v14a2 2 0 01-2 2H5a2 2 0 01-2-2V5c0-1.1.9-2 2-2zm0 2v14h14V5H5zm11 7a1 1 0 01-1 1H9a1 1 0 010-2h6a1 1 0 011 1z"
  }));
};

exports.IconMinusSquare = IconMinusSquare;

var IconMinus = function IconMinus(props) {
  return React.createElement("svg", __assign({
    viewBox: "0 0 24 24",
    width: 24,
    height: 24
  }, props), React.createElement("path", {
    className: "heroicon-ui",
    d: "M17 11a1 1 0 010 2H7a1 1 0 010-2h10z"
  }));
};

exports.IconMinus = IconMinus;

var IconMobile = function IconMobile(props) {
  return React.createElement("svg", __assign({
    viewBox: "0 0 24 24",
    width: 24,
    height: 24
  }, props), React.createElement("path", {
    className: "heroicon-ui",
    d: "M8 2h8a2 2 0 012 2v16a2 2 0 01-2 2H8a2 2 0 01-2-2V4c0-1.1.9-2 2-2zm0 2v16h8V4H8zm4 14a1 1 0 110-2 1 1 0 010 2z"
  }));
};

exports.IconMobile = IconMobile;

var IconMoon = function IconMoon(props) {
  return React.createElement("svg", __assign({
    viewBox: "0 0 24 24",
    width: 24,
    height: 24
  }, props), React.createElement("path", {
    className: "heroicon-ui",
    d: "M9.57 3.38a8 8 0 0010.4 10.4 1 1 0 011.31 1.3 10 10 0 11-13-13 1 1 0 011.3 1.3zM7.1 5.04a8 8 0 1011.2 11.23A10 10 0 017.08 5.04z"
  }));
};

exports.IconMoon = IconMoon;

var IconMoreHoriz = function IconMoreHoriz(props) {
  return React.createElement("svg", __assign({
    viewBox: "0 0 24 24",
    width: 24,
    height: 24
  }, props), React.createElement("path", {
    className: "heroicon-ui",
    d: "M4 15a3 3 0 110-6 3 3 0 010 6zm0-2a1 1 0 100-2 1 1 0 000 2zm8 2a3 3 0 110-6 3 3 0 010 6zm0-2a1 1 0 100-2 1 1 0 000 2zm8 2a3 3 0 110-6 3 3 0 010 6zm0-2a1 1 0 100-2 1 1 0 000 2z"
  }));
};

exports.IconMoreHoriz = IconMoreHoriz;

var IconMusic = function IconMusic(props) {
  return React.createElement("svg", __assign({
    viewBox: "0 0 24 24",
    width: 24,
    height: 24
  }, props), React.createElement("path", {
    className: "heroicon-ui",
    d: "M8 14.54V6a1 1 0 01.76-.97l12-3A1 1 0 0122 3v12a4 4 0 11-2-3.46V4.28l-10 2.5V18a4 4 0 11-2-3.46zM6 20a2 2 0 100-4 2 2 0 000 4zm12-3a2 2 0 100-4 2 2 0 000 4z"
  }));
};

exports.IconMusic = IconMusic;

var IconNews = function IconNews(props) {
  return React.createElement("svg", __assign({
    viewBox: "0 0 24 24",
    width: 24,
    height: 24
  }, props), React.createElement("path", {
    className: "heroicon-ui",
    d: "M18 21H7a4 4 0 01-4-4V5c0-1.1.9-2 2-2h10a2 2 0 012 2h2a2 2 0 012 2v11a3 3 0 01-3 3zm-3-3V5H5v12c0 1.1.9 2 2 2h8.17a3 3 0 01-.17-1zm-7-3h4a1 1 0 010 2H8a1 1 0 010-2zm0-4h4a1 1 0 010 2H8a1 1 0 010-2zm0-4h4a1 1 0 010 2H8a1 1 0 110-2zm9 11a1 1 0 002 0V7h-2v11z"
  }));
};

exports.IconNews = IconNews;

var IconNotification = function IconNotification(props) {
  return React.createElement("svg", __assign({
    viewBox: "0 0 24 24",
    width: 24,
    height: 24
  }, props), React.createElement("path", {
    className: "heroicon-ui",
    d: "M15 19a3 3 0 01-6 0H4a1 1 0 010-2h1v-6a7 7 0 014.02-6.34 3 3 0 015.96 0A7 7 0 0119 11v6h1a1 1 0 010 2h-5zm-4 0a1 1 0 002 0h-2zm0-12.9A5 5 0 007 11v6h10v-6a5 5 0 00-4-4.9V5a1 1 0 00-2 0v1.1z"
  }));
};

exports.IconNotification = IconNotification;

var IconPlusCircle = function IconPlusCircle(props) {
  return React.createElement("svg", __assign({
    viewBox: "0 0 24 24",
    width: 24,
    height: 24
  }, props), React.createElement("path", {
    className: "heroicon-ui",
    d: "M12 22a10 10 0 110-20 10 10 0 010 20zm0-2a8 8 0 100-16 8 8 0 000 16zm1-9h2a1 1 0 010 2h-2v2a1 1 0 01-2 0v-2H9a1 1 0 010-2h2V9a1 1 0 012 0v2z"
  }));
};

exports.IconPlusCircle = IconPlusCircle;

var IconPlusSquare = function IconPlusSquare(props) {
  return React.createElement("svg", __assign({
    viewBox: "0 0 24 24",
    width: 24,
    height: 24
  }, props), React.createElement("path", {
    className: "heroicon-ui",
    d: "M5 3h14a2 2 0 012 2v14a2 2 0 01-2 2H5a2 2 0 01-2-2V5c0-1.1.9-2 2-2zm0 2v14h14V5H5zm8 6h2a1 1 0 010 2h-2v2a1 1 0 01-2 0v-2H9a1 1 0 010-2h2V9a1 1 0 012 0v2z"
  }));
};

exports.IconPlusSquare = IconPlusSquare;

var IconPlus = function IconPlus(props) {
  return React.createElement("svg", __assign({
    viewBox: "0 0 24 24",
    width: 24,
    height: 24
  }, props), React.createElement("path", {
    className: "heroicon-ui",
    d: "M17 11a1 1 0 010 2h-4v4a1 1 0 01-2 0v-4H7a1 1 0 010-2h4V7a1 1 0 012 0v4h4z"
  }));
};

exports.IconPlus = IconPlus;

var IconPrint = function IconPrint(props) {
  return React.createElement("svg", __assign({
    viewBox: "0 0 24 24",
    width: 24,
    height: 24
  }, props), React.createElement("path", {
    className: "heroicon-ui",
    d: "M18 18v2a2 2 0 01-2 2H8a2 2 0 01-2-2v-2H4a2 2 0 01-2-2v-6c0-1.1.9-2 2-2h2V4c0-1.1.9-2 2-2h8a2 2 0 012 2v4h2a2 2 0 012 2v6a2 2 0 01-2 2h-2zm0-2h2v-6H4v6h2v-2c0-1.1.9-2 2-2h8a2 2 0 012 2v2zm-2-8V4H8v4h8zm-8 6v6h8v-6H8z"
  }));
};

exports.IconPrint = IconPrint;

var IconPuzzle = function IconPuzzle(props) {
  return React.createElement("svg", __assign({
    viewBox: "0 0 24 24",
    width: 24,
    height: 24
  }, props), React.createElement("path", {
    className: "heroicon-ui",
    d: "M17 22a2 2 0 01-2-2v-1a1 1 0 00-1-1 1 1 0 00-1 1v1a2 2 0 01-2 2H8a2 2 0 01-2-2v-3H5a3 3 0 110-6h1V8a2 2 0 012-2h3V5a3 3 0 116 0v1h3a2 2 0 012 2v3a2 2 0 01-2 2h-1a1 1 0 00-1 1 1 1 0 001 1h1a2 2 0 012 2v3a2 2 0 01-2 2h-3zm3-2v-3h-1a3 3 0 110-6h1V8h-3a2 2 0 01-2-2V5a1 1 0 00-1-1 1 1 0 00-1 1v1a2 2 0 01-2 2H8v3a2 2 0 01-2 2H5a1 1 0 00-1 1 1 1 0 001 1h1a2 2 0 012 2v3h3v-1a3 3 0 116 0v1h3z"
  }));
};

exports.IconPuzzle = IconPuzzle;

var IconRefresh = function IconRefresh(props) {
  return React.createElement("svg", __assign({
    viewBox: "0 0 24 24",
    width: 24,
    height: 24
  }, props), React.createElement("path", {
    className: "heroicon-ui",
    d: "M6 18.7V21a1 1 0 01-2 0v-5a1 1 0 011-1h5a1 1 0 110 2H7.1A7 7 0 0019 12a1 1 0 112 0 9 9 0 01-15 6.7zM18 5.3V3a1 1 0 012 0v5a1 1 0 01-1 1h-5a1 1 0 010-2h2.9A7 7 0 005 12a1 1 0 11-2 0 9 9 0 0115-6.7z"
  }));
};

exports.IconRefresh = IconRefresh;

var IconRepeat = function IconRepeat(props) {
  return React.createElement("svg", __assign({
    viewBox: "0 0 24 24",
    width: 24,
    height: 24
  }, props), React.createElement("path", {
    className: "heroicon-ui",
    d: "M5.41 16H18a2 2 0 002-2 1 1 0 012 0 4 4 0 01-4 4H5.41l2.3 2.3a1 1 0 01-1.42 1.4l-4-4a1 1 0 010-1.4l4-4a1 1 0 111.42 1.4L5.4 16zM6 8a2 2 0 00-2 2 1 1 0 01-2 0 4 4 0 014-4h12.59l-2.3-2.3a1 1 0 111.42-1.4l4 4a1 1 0 010 1.4l-4 4a1 1 0 01-1.42-1.4L18.6 8H6z"
  }));
};

exports.IconRepeat = IconRepeat;

var IconRocket = function IconRocket(props) {
  return React.createElement("svg", __assign({
    viewBox: "0 0 24 24",
    width: 24,
    height: 24
  }, props), React.createElement("path", {
    className: "heroicon-ui",
    d: "M16.21 16.95a5 5 0 01-4.02 4.9l-3.85.77a1 1 0 01-.9-.27l-.71-.7a2 2 0 010-2.83l1.44-1.45a13.17 13.17 0 01-1.42-1.41L5.31 17.4a2 2 0 01-2.83 0l-.7-.7a1 1 0 01-.28-.9l.77-3.86a5 5 0 014.9-4.02h.86a13.07 13.07 0 0112.82-5.47 1 1 0 01.83.83A12.98 12.98 0 0116.2 16.1v.85zm-4.41 2.94a3 3 0 002.41-2.94v-1.4a1 1 0 01.47-.84A11.04 11.04 0 0019.8 4.33 10.98 10.98 0 009.42 9.45a1 1 0 01-.85.47h-1.4a3 3 0 00-2.94 2.4l-.66 3.34.33.33 2.24-2.24a1 1 0 011.52.12 11.08 11.08 0 002.6 2.6 1 1 0 01.12 1.52l-2.24 2.24.33.33 3.33-.67zM15 10a1 1 0 110-2 1 1 0 010 2z"
  }));
};

exports.IconRocket = IconRocket;

var IconSearch = function IconSearch(props) {
  return React.createElement("svg", __assign({
    viewBox: "0 0 24 24",
    width: 24,
    height: 24
  }, props), React.createElement("path", {
    className: "heroicon-ui",
    d: "M16.32 14.9l5.39 5.4a1 1 0 01-1.42 1.4l-5.38-5.38a8 8 0 111.41-1.41zM10 16a6 6 0 100-12 6 6 0 000 12z"
  }));
};

exports.IconSearch = IconSearch;

var IconServer = function IconServer(props) {
  return React.createElement("svg", __assign({
    viewBox: "0 0 24 24",
    width: 24,
    height: 24
  }, props), React.createElement("path", {
    className: "heroicon-ui",
    d: "M5 3h14a2 2 0 012 2v14a2 2 0 01-2 2H5a2 2 0 01-2-2V5c0-1.1.9-2 2-2zm14 8V5H5v6h14zm0 2H5v6h14v-6zM8 9a1 1 0 110-2 1 1 0 010 2zm0 8a1 1 0 110-2 1 1 0 010 2z"
  }));
};

exports.IconServer = IconServer;

var IconSpeaker = function IconSpeaker(props) {
  return React.createElement("svg", __assign({
    viewBox: "0 0 24 24",
    width: 24,
    height: 24
  }, props), React.createElement("path", {
    className: "heroicon-ui",
    d: "M6 2h12a2 2 0 012 2v16a2 2 0 01-2 2H6a2 2 0 01-2-2V4c0-1.1.9-2 2-2zm0 2v16h12V4H6zm6 14a4 4 0 110-8 4 4 0 010 8zm0-2a2 2 0 100-4 2 2 0 000 4zm0-8a1 1 0 110-2 1 1 0 010 2z"
  }));
};

exports.IconSpeaker = IconSpeaker;

var IconStar = function IconStar(props) {
  return React.createElement("svg", __assign({
    viewBox: "0 0 24 24",
    width: 24,
    height: 24
  }, props), React.createElement("path", {
    className: "heroicon-ui",
    d: "M6.1 21.98a1 1 0 01-1.45-1.06l1.03-6.03-4.38-4.26a1 1 0 01.56-1.71l6.05-.88 2.7-5.48a1 1 0 011.8 0l2.7 5.48 6.06.88a1 1 0 01.55 1.7l-4.38 4.27 1.04 6.03a1 1 0 01-1.46 1.06l-5.4-2.85-5.42 2.85zm4.95-4.87a1 1 0 01.93 0l4.08 2.15-.78-4.55a1 1 0 01.29-.88l3.3-3.22-4.56-.67a1 1 0 01-.76-.54l-2.04-4.14L9.47 9.4a1 1 0 01-.75.54l-4.57.67 3.3 3.22a1 1 0 01.3.88l-.79 4.55 4.09-2.15z"
  }));
};

exports.IconStar = IconStar;

var IconStore = function IconStore(props) {
  return React.createElement("svg", __assign({
    viewBox: "0 0 24 24",
    width: 24,
    height: 24
  }, props), React.createElement("path", {
    className: "heroicon-ui",
    d: "M20 11.46V20a2 2 0 01-2 2h-3a2 2 0 01-2-2v-4h-2v4a2 2 0 01-2 2H6a2 2 0 01-2-2v-8.54A4 4 0 012 8V7a1 1 0 01.1-.45l2-4A1 1 0 015 2h14a1 1 0 01.9.55l2 4c.06.14.1.3.1.45v1a4 4 0 01-2 3.46zM18 12c-1.2 0-2.27-.52-3-1.35a3.99 3.99 0 01-6 0A3.99 3.99 0 016 12v8h3v-4c0-1.1.9-2 2-2h2a2 2 0 012 2v4h3v-8zm2-4h-4a2 2 0 104 0zm-6 0h-4a2 2 0 104 0zM8 8H4a2 2 0 104 0zm11.38-2l-1-2H5.62l-1 2h14.76z"
  }));
};

exports.IconStore = IconStore;

var IconTablet = function IconTablet(props) {
  return React.createElement("svg", __assign({
    viewBox: "0 0 24 24",
    width: 24,
    height: 24
  }, props), React.createElement("path", {
    className: "heroicon-ui",
    d: "M6 2h12a2 2 0 012 2v16a2 2 0 01-2 2H6a2 2 0 01-2-2V4c0-1.1.9-2 2-2zm0 2v16h12V4H6zm6 14a1 1 0 110-2 1 1 0 010 2z"
  }));
};

exports.IconTablet = IconTablet;

var IconTag = function IconTag(props) {
  return React.createElement("svg", __assign({
    viewBox: "0 0 24 24",
    width: 24,
    height: 24
  }, props), React.createElement("path", {
    className: "heroicon-ui",
    d: "M2.59 13.41A1.98 1.98 0 012 12V7a5 5 0 015-5h4.99c.53 0 1.04.2 1.42.59l8 8a2 2 0 010 2.82l-8 8a2 2 0 01-2.82 0l-8-8zM20 12l-8-8H7a3 3 0 00-3 3v5l8 8 8-8zM7 8a1 1 0 110-2 1 1 0 010 2z"
  }));
};

exports.IconTag = IconTag;

var IconThumbDown = function IconThumbDown(props) {
  return React.createElement("svg", __assign({
    viewBox: "0 0 24 24",
    width: 24,
    height: 24
  }, props), React.createElement("path", {
    className: "heroicon-ui",
    d: "M6.38 14H4a2 2 0 01-2-2V4c0-1.1.9-2 2-2h11.5c1.2 0 2.3.72 2.74 1.79l3.5 7 .03.06A3 3 0 0119 15h-5v5a2 2 0 01-2 2h-1.62l-4-8zM8 12.76L11.62 20H12v-7h7c.13 0 .25-.02.38-.08a1 1 0 00.55-1.28l-3.5-7.02A1 1 0 0015.5 4H8v8.76zM6 12V4H4v8h2z"
  }));
};

exports.IconThumbDown = IconThumbDown;

var IconThumbUp = function IconThumbUp(props) {
  return React.createElement("svg", __assign({
    viewBox: "0 0 24 24",
    width: 24,
    height: 24
  }, props), React.createElement("path", {
    className: "heroicon-ui",
    d: "M17.62 10H20a2 2 0 012 2v8a2 2 0 01-2 2H8.5c-1.2 0-2.3-.72-2.74-1.79l-3.5-7-.03-.06A3 3 0 015 9h5V4c0-1.1.9-2 2-2h1.62l4 8zM16 11.24L12.38 4H12v7H5a1 1 0 00-.93 1.36l3.5 7.02a1 1 0 00.93.62H16v-8.76zm2 .76v8h2v-8h-2z"
  }));
};

exports.IconThumbUp = IconThumbUp;

var IconTrash = function IconTrash(props) {
  return React.createElement("svg", __assign({
    viewBox: "0 0 24 24",
    width: 24,
    height: 24
  }, props), React.createElement("path", {
    className: "heroicon-ui",
    d: "M8 6V4c0-1.1.9-2 2-2h4a2 2 0 012 2v2h5a1 1 0 010 2h-1v12a2 2 0 01-2 2H6a2 2 0 01-2-2V8H3a1 1 0 110-2h5zM6 8v12h12V8H6zm8-2V4h-4v2h4zm-4 4a1 1 0 011 1v6a1 1 0 01-2 0v-6a1 1 0 011-1zm4 0a1 1 0 011 1v6a1 1 0 01-2 0v-6a1 1 0 011-1z"
  }));
};

exports.IconTrash = IconTrash;

var IconTrendingDown = function IconTrendingDown(props) {
  return React.createElement("svg", __assign({
    viewBox: "0 0 24 24",
    width: 24,
    height: 24
  }, props), React.createElement("path", {
    className: "heroicon-ui",
    d: "M20 9a1 1 0 012 0v8a1 1 0 01-1 1h-8a1 1 0 010-2h5.59L13 10.41l-3.3 3.3a1 1 0 01-1.4 0l-6-6a1 1 0 011.4-1.42L9 11.6l3.3-3.3a1 1 0 011.4 0l6.3 6.3V9z"
  }));
};

exports.IconTrendingDown = IconTrendingDown;

var IconTrendingUp = function IconTrendingUp(props) {
  return React.createElement("svg", __assign({
    viewBox: "0 0 24 24",
    width: 24,
    height: 24
  }, props), React.createElement("path", {
    className: "heroicon-ui",
    d: "M20 15a1 1 0 002 0V7a1 1 0 00-1-1h-8a1 1 0 000 2h5.59L13 13.59l-3.3-3.3a1 1 0 00-1.4 0l-6 6a1 1 0 001.4 1.42L9 12.4l3.3 3.3a1 1 0 001.4 0L20 9.4V15z"
  }));
};

exports.IconTrendingUp = IconTrendingUp;

var IconTrophy = function IconTrophy(props) {
  return React.createElement("svg", __assign({
    viewBox: "0 0 24 24",
    width: 24,
    height: 24
  }, props), React.createElement("path", {
    className: "heroicon-ui",
    d: "M11 20v-2.08a6 6 0 01-4.24-3A4.02 4.02 0 012 11V6c0-1.1.9-2 2-2h2c0-1.1.9-2 2-2h8a2 2 0 012 2h2a2 2 0 012 2v5a4 4 0 01-4.76 3.93A6 6 0 0113 17.92V20h4a1 1 0 010 2H7a1 1 0 010-2h4zm6.92-7H18a2 2 0 002-2V6h-2v6c0 .34-.03.67-.08 1zM6.08 13A6.04 6.04 0 016 12V6H4v5a2 2 0 002.08 2zM8 4v8a4 4 0 108 0V4H8z"
  }));
};

exports.IconTrophy = IconTrophy;

var IconUpload = function IconUpload(props) {
  return React.createElement("svg", __assign({
    viewBox: "0 0 24 24",
    width: 24,
    height: 24
  }, props), React.createElement("path", {
    className: "heroicon-ui",
    d: "M13 5.41V17a1 1 0 01-2 0V5.41l-3.3 3.3a1 1 0 01-1.4-1.42l5-5a1 1 0 011.4 0l5 5a1 1 0 11-1.4 1.42L13 5.4zM3 17a1 1 0 012 0v3h14v-3a1 1 0 012 0v3a2 2 0 01-2 2H5a2 2 0 01-2-2v-3z"
  }));
};

exports.IconUpload = IconUpload;

var IconUserCheck = function IconUserCheck(props) {
  return React.createElement("svg", __assign({
    viewBox: "0 0 24 24",
    width: 24,
    height: 24
  }, props), React.createElement("path", {
    className: "heroicon-ui",
    d: "M9 12A5 5 0 119 2a5 5 0 010 10zm0-2a3 3 0 100-6 3 3 0 000 6zm8 11a1 1 0 01-2 0v-2a3 3 0 00-3-3H7a3 3 0 00-3 3v2a1 1 0 01-2 0v-2a5 5 0 015-5h5a5 5 0 015 5v2zm-1.3-10.7l1.3 1.29 3.3-3.3a1 1 0 011.4 1.42l-4 4a1 1 0 01-1.4 0l-2-2a1 1 0 011.4-1.42z"
  }));
};

exports.IconUserCheck = IconUserCheck;

var IconUserMinus = function IconUserMinus(props) {
  return React.createElement("svg", __assign({
    viewBox: "0 0 24 24",
    width: 24,
    height: 24
  }, props), React.createElement("path", {
    className: "heroicon-ui",
    d: "M9 12A5 5 0 119 2a5 5 0 010 10zm0-2a3 3 0 100-6 3 3 0 000 6zm8 11a1 1 0 01-2 0v-2a3 3 0 00-3-3H7a3 3 0 00-3 3v2a1 1 0 01-2 0v-2a5 5 0 015-5h5a5 5 0 015 5v2zm5-10a1 1 0 01-1 1h-6a1 1 0 010-2h6a1 1 0 011 1z"
  }));
};

exports.IconUserMinus = IconUserMinus;

var IconUserPlus = function IconUserPlus(props) {
  return React.createElement("svg", __assign({
    viewBox: "0 0 24 24",
    width: 24,
    height: 24
  }, props), React.createElement("path", {
    className: "heroicon-ui",
    d: "M19 10h2a1 1 0 010 2h-2v2a1 1 0 01-2 0v-2h-2a1 1 0 010-2h2V8a1 1 0 012 0v2zM9 12A5 5 0 119 2a5 5 0 010 10zm0-2a3 3 0 100-6 3 3 0 000 6zm8 11a1 1 0 01-2 0v-2a3 3 0 00-3-3H7a3 3 0 00-3 3v2a1 1 0 01-2 0v-2a5 5 0 015-5h5a5 5 0 015 5v2z"
  }));
};

exports.IconUserPlus = IconUserPlus;

var IconUser = function IconUser(props) {
  return React.createElement("svg", __assign({
    viewBox: "0 0 24 24",
    width: 24,
    height: 24
  }, props), React.createElement("path", {
    className: "heroicon-ui",
    d: "M12 12a5 5 0 110-10 5 5 0 010 10zm0-2a3 3 0 100-6 3 3 0 000 6zm9 11a1 1 0 01-2 0v-2a3 3 0 00-3-3H8a3 3 0 00-3 3v2a1 1 0 01-2 0v-2a5 5 0 015-5h8a5 5 0 015 5v2z"
  }));
};

exports.IconUser = IconUser;

var IconVideo = function IconVideo(props) {
  return React.createElement("svg", __assign({
    viewBox: "0 0 24 24",
    width: 24,
    height: 24
  }, props), React.createElement("path", {
    className: "heroicon-ui",
    d: "M16 8.38l4.55-2.27A1 1 0 0122 7v10a1 1 0 01-1.45.9L16 15.61V17a2 2 0 01-2 2H4a2 2 0 01-2-2V7c0-1.1.9-2 2-2h10a2 2 0 012 2v1.38zm0 2.24v2.76l4 2V8.62l-4 2zM14 17V7H4v10h10z"
  }));
};

exports.IconVideo = IconVideo;

var IconView = function IconView(props) {
  return React.createElement("svg", __assign({
    viewBox: "0 0 24 24",
    width: 24,
    height: 24
  }, props), React.createElement("path", {
    className: "heroicon-ui",
    d: "M17.56 17.66a8 8 0 01-11.32 0L1.3 12.7a1 1 0 010-1.42l4.95-4.95a8 8 0 0111.32 0l4.95 4.95a1 1 0 010 1.42l-4.95 4.95zm-9.9-1.42a6 6 0 008.48 0L20.38 12l-4.24-4.24a6 6 0 00-8.48 0L3.4 12l4.25 4.24zM11.9 16a4 4 0 110-8 4 4 0 010 8zm0-2a2 2 0 100-4 2 2 0 000 4z"
  }));
};

exports.IconView = IconView;

var IconXCircle = function IconXCircle(props) {
  return React.createElement("svg", __assign({
    viewBox: "0 0 24 24",
    width: 24,
    height: 24
  }, props), React.createElement("path", {
    className: "heroicon-ui",
    d: "M4.93 19.07A10 10 0 1119.07 4.93 10 10 0 014.93 19.07zm1.41-1.41A8 8 0 1017.66 6.34 8 8 0 006.34 17.66zM13.41 12l1.42 1.41a1 1 0 11-1.42 1.42L12 13.4l-1.41 1.42a1 1 0 11-1.42-1.42L10.6 12l-1.42-1.41a1 1 0 111.42-1.42L12 10.6l1.41-1.42a1 1 0 111.42 1.42L13.4 12z"
  }));
};

exports.IconXCircle = IconXCircle;

var IconXSquare = function IconXSquare(props) {
  return React.createElement("svg", __assign({
    viewBox: "0 0 24 24",
    width: 24,
    height: 24
  }, props), React.createElement("path", {
    className: "heroicon-ui",
    d: "M5 3h14a2 2 0 012 2v14a2 2 0 01-2 2H5a2 2 0 01-2-2V5c0-1.1.9-2 2-2zm0 2v14h14V5H5zm8.41 7l1.42 1.41a1 1 0 11-1.42 1.42L12 13.4l-1.41 1.42a1 1 0 11-1.42-1.42L10.6 12l-1.42-1.41a1 1 0 111.42-1.42L12 10.6l1.41-1.42a1 1 0 111.42 1.42L13.4 12z"
  }));
};

exports.IconXSquare = IconXSquare;

var IconX = function IconX(props) {
  return React.createElement("svg", __assign({
    viewBox: "0 0 24 24",
    width: 24,
    height: 24
  }, props), React.createElement("path", {
    className: "heroicon-ui",
    d: "M16.24 14.83a1 1 0 01-1.41 1.41L12 13.41l-2.83 2.83a1 1 0 01-1.41-1.41L10.59 12 7.76 9.17a1 1 0 011.41-1.41L12 10.59l2.83-2.83a1 1 0 011.41 1.41L13.41 12l2.83 2.83z"
  }));
};

exports.IconX = IconX;

var IconZoomIn = function IconZoomIn(props) {
  return React.createElement("svg", __assign({
    viewBox: "0 0 24 24",
    width: 24,
    height: 24
  }, props), React.createElement("path", {
    className: "heroicon-ui",
    d: "M16.32 14.9l5.39 5.4a1 1 0 01-1.42 1.4l-5.38-5.38a8 8 0 111.41-1.41zM10 16a6 6 0 100-12 6 6 0 000 12zm1-7h2a1 1 0 010 2h-2v2a1 1 0 01-2 0v-2H7a1 1 0 010-2h2V7a1 1 0 112 0v2z"
  }));
};

exports.IconZoomIn = IconZoomIn;

var IconZoomOut = function IconZoomOut(props) {
  return React.createElement("svg", __assign({
    viewBox: "0 0 24 24",
    width: 24,
    height: 24
  }, props), React.createElement("path", {
    className: "heroicon-ui",
    d: "M16.32 14.9l5.39 5.4a1 1 0 01-1.42 1.4l-5.38-5.38a8 8 0 111.41-1.41zM10 16a6 6 0 100-12 6 6 0 000 12zm4-6a1 1 0 01-1 1H7a1 1 0 010-2h6a1 1 0 011 1z"
  }));
};

exports.IconZoomOut = IconZoomOut;